export class SerializrType_custom {
    customSerializer;
    customDeserializer;
    constructor(customSerializer, customDeserializer) {
        this.customSerializer = customSerializer;
        this.customDeserializer = customDeserializer;
    }
    serializer({ value }) {
        return this.customSerializer(value);
    }
    deserializer(context) {
        return this.customDeserializer(context.json);
    }
}
export function custom(customSerializer, customDeserializer = () => { }) {
    return new SerializrType_custom(customSerializer, customDeserializer);
}
